import {
    Center,
    Stack,
    Title,
    Text,
    ThemeIcon,
    Anchor,
} from '@mantine/core';
import { Icon } from '@iconify/react';
import { Link } from 'react-router-dom';
import PasswordResetForm from 'src/components/auth/PasswordResetForm';

export default function ResetPassword() {

    return (
        <Center pt={100} p="md">
            <Stack gap="lg" align="center">
                {/* Icon */}
                <ThemeIcon
                    size={60}
                    radius="xl"
                    variant="light"
                    color="green"
                >
                    <Icon icon="mdi:lock-check" width={30} height={30} />
                </ThemeIcon>

                {/* Header */}
                <Stack gap="xs" align="center">
                    <Title order={2}>Reset Password</Title>
                    <Text c="dimmed" size="sm" ta="center" maw={350}>
                        Enter your new password below. Make sure it's at least
                        8 characters and includes a letter.
                    </Text>
                </Stack>

                {/* Form */}
                <PasswordResetForm />

                {/* Footer Links */}
                <Anchor component={Link} to="/sign-in" size="sm">
                    <Icon icon="mdi:arrow-left" width={14} style={{ verticalAlign: 'middle', marginRight: 4 }} />
                    Back to Sign In
                </Anchor>
            </Stack>
        </Center>
    );
}
